import toast from "react-hot-toast";
import * as api from "../Api";

const failed = (error, fallback) => {
  toast.error(error?.response?.data?.message || fallback);
  throw error;
};

export const getAllStockItems = () => async (dispatch) => {
  try {
    const { data } = await api.getStockItems();
    dispatch({ type: "STOCK_ITEMS", payload: data });
  } catch (error) {}
};

export const createStockItem = (postData) => async (dispatch) => {
  try {
    const { data } = await api.createStockItems(postData);
    dispatch({ type: "CREATE_STOCK_ITEM", payload: data });
    toast.success(`${data.item} added`);
    return data;
  } catch (error) {
    failed(error, "Couldn't add the item");
  }
};

export const updateStockItem = (id, postData) => async (dispatch) => {
  try {
    const { data } = await api.updateStockItem(id, postData);
    dispatch({ type: "UPDATE_STOCK_ITEM", payload: data });
    toast.success("Item saved");
    return data;
  } catch (error) {
    failed(error, "Couldn't save the item");
  }
};

export const deleteStockItem = (id) => async (dispatch) => {
  try {
    await api.deleteStockItem(id);
    dispatch({ type: "DELETE_STOCK_ITEM", payload: id });
    toast.success("Item deleted");
  } catch (error) {
    failed(error, "Couldn't delete the item");
  }
};
